module.exports = __webpack_public_path__ + "assets/img/31_439.057f7670.jpg";